/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { getUsers, isActionPending } from '@app/user/store/users.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { User } from '@shared/models';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';

@Component({
    selector: 'app-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss'],
    standalone: false
})
export class UserSearchComponent implements OnInit {
  @Input()
  control = new UntypedFormControl();
  filteredUsers$: Observable<User[]>;
  actionPending$: Observable<boolean>;

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.actionPending$ = this.store.select(isActionPending);

    this.filteredUsers$ = this.control.valueChanges.pipe(
      debounceTime(300),
      filter(searchText => searchText.length > 2),
      withLatestFrom(this.store.select(getUsers)),
      map(([searchText, users]) => users.filter(
        user => (user.firstName.toLowerCase() + ' ' + user.lastName.toLowerCase()).includes(searchText.toLowerCase())
      )),
      tap(filteredUsers => {
        if (filteredUsers.length === 1) {
          this.control.setValue(filteredUsers[0]);
        }
      })
    );
  }

  displayUser(user?: User): string {
    return user ? user.firstName + ' ' + user.lastName : '';
  }
}
